export const productTableFiledName = [
    { id: 1, name: 'Product Name' },
    { id: 2, name: 'SKU' },
    { id: 3, name: 'Stock' },
    { id: 4, name: 'Price' },
    { id: 5, name: 'Earning' },
    { id: 6, name: 'Status' },
    { id: 7, name: 'Ratings' },
];

export const chartData = [
    {
        name: 'Jan',
        earnings: 2500,
        sales: 4200,
        amt: 2400,
        order: 2700,
    },
    {
        name: 'Feb',
        earnings: 1000,
        sales: 3398,
        amt: 2210,
        order: 2700,
    },
    {
        name: 'Mar',
        earnings: 2700,
        sales: 4000,
        amt: 2290,
        order: 2700,
    },
    {
        name: 'Apr',
        earnings: 2780,
        sales: 3908,
        amt: 2000,
        order: 2700,
    },
    {
        name: 'May',
        earnings: 1890,
        sales: 4800,
        amt: 2181,
        order: 2700,
    },
    {
        name: 'Jun',
        earnings: 2390,
        sales: 3800,
        amt: 2500,
        order: 2700,
    },
    {
        name: 'Jul',
        earnings: 3490,
        sales: 4300,
        amt: 2100,
        order: 2700,
    },
    {
        name: 'Aug',
        earnings: 2500,
        sales: 4200,
        amt: 2400,
        order: 2700,
    },
    {
        name: 'Sep',
        earnings: 1000,
        sales: 3398,
        amt: 2210,
        order: 2700,
    },
    {
        name: 'Oct',
        earnings: 2700,
        sales: 4000,
        amt: 2290,
        order: 2700,
    },
    {
        name: 'Nov',
        earnings: 2780,
        sales: 3908,
        amt: 2000,
        order: 2700,
    },
    {
        name: 'Dec',
        earnings: 1890,
        sales: 4800,
        amt: 2181,
        order: 2700,
    },
];

export const chartDataLastMonth = [
    {
        name: 'Oct 1',
        earnings: 2500,
        sales: 4200,
        amt: 2400,
        order: 2700,
    },
    {
        name: '2',
        earnings: 1000,
        sales: 3398,
        amt: 2210,
        order: 2700,
    },
    {
        name: '3',
        earnings: 2700,
        sales: 4000,
        amt: 2290,
        order: 2700,
    },
    {
        name: '4',
        earnings: 2780,
        sales: 3908,
        amt: 2000,
        order: 2700,
    },
    {
        name: '5',
        earnings: 1890,
        sales: 4800,
        amt: 2181,
        order: 2700,
    },
    {
        name: '6',
        earnings: 2390,
        sales: 3800,
        amt: 2500,
        order: 2700,
    },
    {
        name: '7',
        earnings: 3490,
        sales: 4300,
        amt: 2100,
        order: 2700,
    },
    {
        name: '8',
        earnings: 2500,
        sales: 4200,
        amt: 2400,
        order: 2700,
    },
    {
        name: '9',
        earnings: 1000,
        sales: 3398,
        amt: 2210,
        order: 2700,
    },
    {
        name: '10',
        earnings: 2700,
        sales: 4000,
        amt: 2290,
        order: 2700,
    },
    {
        name: '11',
        earnings: 2780,
        sales: 3908,
        amt: 2000,
        order: 2700,
    },
    {
        name: '12',
        earnings: 1890,
        sales: 4800,
        amt: 2181,
        order: 2700,
    },
    {
        name: '13',
        earnings: 2500,
        sales: 4200,
        amt: 2400,
        order: 2700,
    },
    {
        name: '14',
        earnings: 1000,
        sales: 3398,
        amt: 2210,
        order: 2700,
    },
    {
        name: '15',
        earnings: 2700,
        sales: 4000,
        amt: 2290,
        order: 2700,
    },
    {
        name: '16',
        earnings: 2780,
        sales: 3908,
        amt: 2000,
        order: 2700,
    },
    {
        name: '17',
        earnings: 1890,
        sales: 4800,
        amt: 2181,
        order: 2700,
    },
    {
        name: '18',
        earnings: 2390,
        sales: 3800,
        amt: 2500,
        order: 2700,
    },
    {
        name: '19',
        earnings: 3490,
        sales: 4300,
        amt: 2100,
        order: 2700,
    },
    {
        name: '20',
        earnings: 2500,
        sales: 4200,
        amt: 2400,
        order: 2700,
    },
    {
        name: '21',
        earnings: 1000,
        sales: 3398,
        amt: 2210,
        order: 2700,
    },
    {
        name: '22',
        earnings: 2700,
        sales: 4000,
        amt: 2290,
        order: 2700,
    },
    {
        name: '23',
        earnings: 2780,
        sales: 3908,
        amt: 2000,
        order: 2700,
    },
    {
        name: '24',
        earnings: 1890,
        sales: 4800,
        amt: 2181,
        order: 2700,
    },
    {
        name: '25',
        earnings: 2390,
        sales: 3800,
        amt: 2500,
        order: 2700,
    },
    {
        name: '26',
        earnings: 3490,
        sales: 4300,
        amt: 2100,
        order: 2700,
    },
    {
        name: '27',
        earnings: 2500,
        sales: 4200,
        amt: 2400,
        order: 2700,
    },
    {
        name: '28',
        earnings: 1000,
        sales: 9000,
        amt: 2210,
        order: 1000,
    },
    {
        name: '29',
        earnings: 2700,
        sales: 4000,
        amt: 2290,
        order: 2700,
    },
    {
        name: '30',
        earnings: 2780,
        sales: 3908,
        amt: 2000,
        order: 2700,
    },
    {
        name: '31',
        earnings: 1890,
        sales: 4800,
        amt: 2181,
        order: 2700,
    },
];
export const chartThisMonth = [
    {
        name: 'Nov 1',
        earnings: 5200,
        sales: 2400,
        amt: 4200,
        order: 10000,
    },
    {
        name: '2',
        earnings: 1100,
        sales: 3938,
        amt: 2130,
        order: 7200,
    },
    {
        name: '3',
        earnings: 2700,
        sales: 4000,
        amt: 2290,
        order: 2700,
    },
    {
        name: '4',
        earnings: 2780,
        sales: 3908,
        amt: 2000,
        order: 2700,
    },
    {
        name: '5',
        earnings: 8190,
        sales: 8300,
        amt: 1821,
        order: 7200,
    },
    {
        name: '6',
        earnings: 2390,
        sales: 3800,
        amt: 2500,
        order: 2700,
    },
    {
        name: '7',
        earnings: 3490,
        sales: 4300,
        amt: 2100,
        order: 2700,
    },
    {
        name: '8',
        earnings: 2500,
        sales: 4200,
        amt: 2400,
        order: 2700,
    },
    {
        name: '9',
        earnings: 1000,
        sales: 3398,
        amt: 2120,
        order: 1700,
    },
    {
        name: '10',
        earnings: 2700,
        sales: 4000,
        amt: 2290,
        order: 2700,
    },
    {
        name: '11',
        earnings: 2780,
        sales: 3908,
        amt: 2000,
        order: 2700,
    },
    {
        name: '12',
        earnings: 1890,
        sales: 4800,
        amt: 2181,
        order: 2700,
    },
    {
        name: '13',
        earnings: 2500,
        sales: 4200,
        amt: 2400,
        order: 2700,
    },
    {
        name: '14',
        earnings: 1000,
        sales: 3398,
        amt: 2210,
        order: 2700,
    },
    {
        name: '15',
        earnings: 2700,
        sales: 4000,
        amt: 2290,
        order: 2700,
    },
    {
        name: '16',
        earnings: 2780,
        sales: 3908,
        amt: 2000,
        order: 2700,
    },
    {
        name: '17',
        earnings: 1890,
        sales: 8000,
        amt: 2181,
        order: 2700,
    },
    {
        name: '18',
        earnings: 2390,
        sales: 3800,
        amt: 2500,
        order: 2700,
    },
    {
        name: '19',
        earnings: 3490,
        sales: 4300,
        amt: 2100,
        order: 2700,
    },
    {
        name: '20',
        earnings: 2500,
        sales: 4200,
        amt: 2400,
        order: 2700,
    },
    {
        name: '21',
        earnings: 1000,
        sales: 9000,
        amt: 2210,
        order: 1000,
    },
    {
        name: '22',
        earnings: 2700,
        sales: 4000,
        amt: 2290,
        order: 2700,
    },
    {
        name: '23',
        earnings: 2780,
        sales: 3908,
        amt: 2000,
        order: 2700,
    },
    {
        name: '24',
        earnings: 1890,
        sales: 4800,
        amt: 2181,
        order: 2700,
    },
];
